import { render, staticRenderFns } from "./AddRoleStaff.vue?vue&type=template&id=0b0db15e"
import script from "./AddRoleStaff.vue?vue&type=script&lang=js"
export * from "./AddRoleStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports